interface ChatProps {
  color?: string;
}

const Chat = ({ color }: ChatProps) => {
  const fillColor = color || 'url(#paint0_linear_338_4417)';
  
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2283 3C6.08613 3 2.72826 6.35786 2.72826 10.5C2.72826 11.6329 2.97993 12.7088 3.43092 13.6734C3.17689 14.6714 2.89307 15.7842 2.70668 16.5147C2.47365 17.428 3.29609 18.2588 4.21042 18.039C4.96065 17.8587 6.11367 17.5819 7.14115 17.337C8.08346 17.7631 9.1291 18 10.2283 18C14.3704 18 17.7283 14.6421 17.7283 10.5C17.7283 6.35786 14.3704 3 10.2283 3ZM4.22826 10.5C4.22826 7.18629 6.91455 4.5 10.2283 4.5C13.542 4.5 16.2283 7.18629 16.2283 10.5C16.2283 13.8137 13.542 16.5 10.2283 16.5C9.26753 16.5 8.36156 16.2748 7.5583 15.8749L7.31489 15.7537L7.05037 15.8167C6.12764 16.0363 5.06158 16.2919 4.26261 16.4838C4.46136 15.7047 4.72453 14.6724 4.95269 13.7757L5.02288 13.4998L4.89236 13.2468C4.46814 12.4246 4.22826 11.4914 4.22826 10.5ZM15.2283 21.0001C13.2589 21.0001 11.4668 20.241 10.1286 18.9995C10.1618 18.9999 10.195 19.0001 10.2283 19.0001C10.9463 19.0001 11.6435 18.911 12.3094 18.7434C13.1734 19.2254 14.1687 19.5001 15.2283 19.5001C16.189 19.5001 17.095 19.2748 17.8983 18.8749L18.1417 18.7537L18.4062 18.8167C19.3277 19.0361 20.3713 19.2625 21.1453 19.4262C20.9704 18.6757 20.7317 17.6711 20.5039 16.7757L20.4337 16.4999L20.5642 16.2469C20.9884 15.4247 21.2283 14.4915 21.2283 13.5001C21.2283 11.3853 20.1343 9.52617 18.4813 8.45761C18.3029 7.73435 18.032 7.04756 17.6817 6.41052C20.619 7.42684 22.7283 10.2171 22.7283 13.5001C22.7283 14.6332 22.4765 15.7094 22.0253 16.6741C22.2783 17.6821 22.5346 18.774 22.6971 19.4773C22.9015 20.3623 22.1221 21.1633 21.2297 20.9768C20.5025 20.8248 19.36 20.581 18.3162 20.3367C17.3737 20.763 16.3278 21.0001 15.2283 21.0001Z"
        fill={fillColor}
      />
      {!color && (
        <defs>
          <linearGradient
            id="paint0_linear_338_4417"
            x1="2.71998"
            y1="3"
            x2="42.5795"
            y2="13.4425"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A256BC" />
            <stop offset="1" stopColor="#298ee6" />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
};
export default Chat;
